<template>
    <b-modal size="lg" id="shopware6_manager_modal">
        <template slot="modal-title">Manage general Shopware 6 config</template>
        <v-app class="v-appNoBackground v-app">
            <b-form ref="shopware6_manager_modal_form">
                <h3>Order import config</h3>
                <hr/>

                <b-form-group label="Start date for the order import.">
                    <b-form-input
                            type="date"
                            id="orderStartDate"
                            :state="isNotNullAndUndefinedAndEmpty(shopware6Config.orderStartDate)"
                            v-model="shopware6Config.orderStartDate"
                            required/>
                </b-form-group>
                <hr/>
                <h4>Shopware payment id to payment status mapping for import</h4>
                <b-form-group>
                    <div class="row">
                        <p class="col-5">Shopware payment ID</p>
                        <p class="col-5">Shopware payment status</p>
                        <p class="col-1">Delete</p>
                    </div>
                    <div class="row"
                         v-for="(paymentId) in objectKeys(shopware6Config.paymentIdToPaymentStatusMapping)"
                         :key="componentKey">
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input :value="paymentId" readonly/>
                            </b-form-group>
                        </div>
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input
                                        id="paymentStatusMap"
                                        placeholder="17"
                                        :state="isNotNullAndUndefinedAndEmpty(shopware6Config.paymentIdToPaymentStatusMapping[paymentId])"
                                        v-model="shopware6Config.paymentIdToPaymentStatusMapping[paymentId]"
                                        @change="forceRerender()"
                                        required/>
                            </b-form-group>
                        </div>
                        <div class="col-1 lowProfileRow">
                            <v-btn icon
                                   @click="forceRerender(), delete shopware6Config.paymentIdToPaymentStatusMapping[paymentId]">
                                <v-icon color="error">mdi-minus-circle</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <hr/>
                    <b-form-group label="Add new payment id to status map">
                        <div class="row">
                            <div class="col-10">
                                <b-form-input id="newPaymentIdForStatus"
                                              placeholder="5"
                                              class="form-control-sm"
                                              v-model="tempVars.newPaymentIdForPaymentStatusField"/>
                            </div>
                            <div class="col-2">
                                <v-btn icon
                                       @click='forceRerender(), shopware6Config.paymentIdToPaymentStatusMapping[tempVars.newPaymentIdForPaymentStatusField] = "", tempVars.newPaymentIdForPaymentStatusField = ""'
                                       :disabled="!isNotNullAndUndefinedAndEmpty(tempVars.newPaymentIdForPaymentStatusField)">
                                    <v-icon color="success">mdi-plus-circle</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </b-form-group>
                </b-form-group>
                <hr/>

            </b-form>
            <i>*Makes sure all the field are present, does not validate their value.</i>
        </v-app>
        <template slot="modal-footer">
            <b-button block
                      variant="secondary"
                      @click="forceRerender">
                Check required fields
                <v-icon dark>mdi-file-document-box-search-outline</v-icon>
                *
            </b-button>
            <v-divider vertical/>
            <b-button block
                      variant="primary"
                      @click="save">
                Save config
                <v-icon dark>mdi-content-save-outline</v-icon>
            </b-button>
        </template>
    </b-modal>
</template>
<script>
    import ProjectRepository from '../../../repositories/project.repository'

    export default {
        props: {
            projectConfig: {
                type: Object,
                default: () => {
                }
            },
            projectId: {
                type: Number,
                default: -1
            }
        },
        data() {
            return {
                componentKey: 0,
                tempVars: {
                    newPaymentIdForPaymentStatusField: null,
                },
                shopware6Config: {
                    orderStartDate: null,
                    paymentIdToPaymentStatusMapping: {},
                },
            }
        },
        methods: {
            save() {
                this.forceRerender();
                if (this.$refs.shopware6_manager_modal_form.checkValidity()) {
                    this.projectConfig.shopware6Config = this.shopware6Config;
                    this.$emit('show-loading-pop-up', "Saving the project Config");
                    this.$bvModal.hide('shopware6_manager_modal');
                    ProjectRepository.saveProjectConfig(this.projectConfig, this.projectId).then(res => {
                        this.$emit('reset-loading-pop-up');
                        this.$emit('saved-project-config');
                        this.$bvToast.toast('Successfully saved the project config', {
                            title: `Config save successful.`,
                            variant: 'success',
                            solid: true
                        });
                    }).catch(error => {
                        this.$bvModal.show('shopware6_manager_modal');
                        console.error(error);
                        this.$bvToast.toast('Looks like something went wrong on the server while saving the project config.', {
                            title: `Config save error.`,
                            variant: 'danger',
                            solid: true
                        });
                    });
                }
            },
            isNotNullAndUndefinedAndEmpty(value) {
                return (value !== undefined && value !== null && value !== "");
            },
            objectKeys(val) {
                return Object.keys(val);
            },
            forceRerender() {
                this.componentKey++;
            }
        },
        watch: {
            projectConfig() {
                if (this.projectConfig.shopware6Config !== undefined) {
                    this.shopware6Config = this.projectConfig.shopware6Config;
                }
            }
        }
    }
</script>

<style>
    .lowProfileRow {
        padding-bottom: 1px !important;
        padding-top: 1px !important;
    }
</style>
